<template>
  <div>
    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 150px;"
      :baseZIndex=-10
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Button 
              v-for="(obj, index) in getButtons(selectedRow)" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="obj.command()"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <DataTable
      :value="attachemts"
      :paginator="true"
      dataKey="attachId"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedContacts"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Attachemts"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
      :style="{ 'width': '100%' }"
      :resizableColumns="true" 
      columnResizeMode="expand"
    >
      <template #empty> No attachemts found. </template>
      <template #loading> Loading attachemts data. Please wait. </template>
      <!-- <Column selectionMode="single" headerStyle="width: 3em;"></Column> -->
      
      <Column 
        header="Actions"
        headerStyle="width: 50px; padding: 7.5px 0px;"
        :frozen="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            <Button 
              icon="pi pi-ellipsis-h" 
              class="p-button-rounded p-button-text"
              @click="toggleActions($event, slotProps.data)"
            />
          </div>
        </template>
      </Column>
      <Column
        field="fileName"
        header="File Name"
        headerStyle="width: 15em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.fileName }}
          </div>
        </template>
      </Column>
      
      <Column
        field="attachDesc"
        header="File Description"
        headerStyle="width: 8em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.attachDesc
                ? slotProps.data.attachDesc.length > 18
                  ? slotProps.data.attachDesc.substring(0, 18) + '...' 
                  : slotProps.data.attachDesc
                : ""
             }}
          </div>
        </template>
      </Column>
      
      <Column
        field="customerId"
        header="Customer Name"
        headerStyle="width: 8em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.customer && slotProps.data.customer.custName ? slotProps.data.customer.custName : '' }}
          </div>
        </template>
      </Column>
      
      <Column
        field="createdBy"
        header="Created By"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.createdBy && slotProps.data.createdBy.fullName ? slotProps.data.createdBy.fullName : '' }}
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import AttachmentService from "@/service/AttachmentService";
import PermissionMixin from '../../PermissionMixin.vue'

export default {
  mixins: [PermissionMixin],
  props: [
    'attachemts', 
    'filters',
    'loading'
  ],
  data() {
    return {
      attachmentService: new AttachmentService(),
      selectedContacts: null,
      selectedRow: null
    }
  },
  created() {
    
  },
  methods: {
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    toggleActions(event, data) {
      this.selectedRow = data
      this.$refs.opActions.toggle(event);
    },
    getButtons(data) {
      this.checkPermissions()
      let buttons = [
				{
					label: 'Download',
					icon: 'pi pi-download',
					command: () => {
						this.download(data)
					}
        }
      ]
      if (this.deleteAttachment) {
        buttons.push(
          {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
              this.askDeleteAttachment(data)
            }
          }
        )
      }
      return buttons
    },
    download(attachment) {
      
      this.attachmentService
        .fileDownloader(attachment.fileName)
    },
    // C-S16: not called deleteAttachment - that name is PermissionMixin's permission flag, which
    // replaced the method and made Delete throw
    askDeleteAttachment(attachment) {
      if (this.$refs.opActions) this.$refs.opActions.hide()
      this.$emit('delete', attachment)
    },
    editAttachments(attachemt) {
      this.$emit('edit', attachemt)
    }
  }
}
</script>

<style>

</style>